import CryptoJS from 'crypto-js';
import base64 from 'base-64';
export function validateEmail(email) {
  // Regex for validating email addresses
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}
export function validateEmail2(email) {
  // Regex for validating email addresses
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase());
}
export function isValidURL(url) {
  const regex = /^(ftp|http|https):\/\/|^(www\.)[^ "]+$/;
  return regex.test(url);
}
export function generateOTP(length, number) {
  const digits = number;
  let otp = '';
  for (let i = 0; i < length; i++) {
    otp += digits[Math.floor(Math.random() * 10)];
  }
  return otp;
}

export const formatTime = seconds => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours} hours, ${minutes} minutes, and ${remainingSeconds} seconds`;
};
export const clintActivityFormatTime = seconds => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedHours = hours < 10 ? `0${hours}` : hours;

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const ViewActivitiesDate = date => {
  const dateTime = new Date(date);

  // Months ke names ko store karne ke liye ek array
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  // Date, month, aur year extract karna
  const datee = dateTime.getDate();
  const monthName = monthNames[dateTime.getMonth()];
  const year = dateTime.getFullYear();

  // Hours, minutes, seconds extract karna
  let hours = dateTime.getHours();
  const minutes = dateTime.getMinutes();
  const seconds = dateTime.getSeconds();

  // AM/PM format ke liye hours ka adjustment karna
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  hours = hours ? hours : 12; // 12-hour clock ke liye 0 bajne par 12 dikha dena

  // Time ka format banana
  const time = `${hours}:${minutes}:${seconds} ${ampm}`;

  // Final date time string
  return ` ${monthName} ${datee}, ${year}, ${time}`;
};

// Encryption function
const encryptData = data => {
  try {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), 'UG_PROJECT').toString();
    return encryptedData;
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

// Decryption function
const decryptData = encryptedData => {
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, 'UG_PROJECT');
    // console.log(decryptedBytes);

    if (!decryptedBytes) {
      return null;
    }
    const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

export { encryptData, decryptData };

export const handleEncrypt = originalData => {
  const encrypted = base64.encode(originalData);
  return encrypted;
};

export const handleDecrypt = encryptedData => {
  const decrypted = base64.decode(encryptedData);
  return decrypted;
};
